/* eslint-disable no-unused-vars, no-undef */

import 'lib/exclude';
import VueDep from 'vue';
import api from 'shared/api';
import Meta from 'vue-meta';
import dayjs from 'dayjs';
import { notifyErrors } from 'shared/helpers/logger';
import router from './config/routes';
import App from './App';
import 'highcharts';
import 'dayjs/locale/id';

const myBody = document.getElementsByTagName('body')[0];
myBody.classList.add('u-bg--sand');

const Vue = window.Vue || VueDep;

const initializeBukareksaSeo = () => {
  Vue.use(Meta);
  Vue.prototype.$api = api;

  dayjs.locale('id');

  Vue.config.errorHandler = e => {
    notifyErrors('SMAUG_BUKAREKSA_SEO', e);
  };

  const app = new Vue({
    el: '#app',
    router,
    render: h => h(App),
  });
};

document.addEventListener('page:load', () => {
  initializeBukareksaSeo();
});

initializeBukareksaSeo();
